import { Card } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import { NoticeSimplified } from 'api/common/types'
import { dateFormatter } from 'utilities/typeUtility'

interface Props {
  notice: NoticeSimplified
}

export const NoticeListCard: React.FC<Props> = ({ notice }) => {
  const navigate = useNavigate()
  const { noticeId, date, title } = notice
  return (
    <Card body className="border-0 mt-3" onClick={() => navigate(`/notificationDetail/${noticeId}`)}>
      <div className="item-date">{dateFormatter(date, 'yyyy/MM/dd')}</div>
      <div className="item-title">{title}</div>
    </Card>
  )
}
